import LatestTransactions from '../home/latest-transactions/LatestTransactions';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { fetchLatestTransactions } from '../transaction/transaction-actions';
import styles from './CMS-transaction-stream.module.less';
import { ContentTitle } from '../components/typography/Heading';
import TransactionStreamListener from '../transaction-stream-listener/TransactionStreamListener';

const CMSTransactionStream = ({ eventId, title }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchLatestTransactions({ eventId }));
    }, [dispatch, eventId]);

    return (
        <div className={styles.liveFeedContainer}>
            <TransactionStreamListener eventIds={[eventId]} />
            {title && <ContentTitle className={styles.title}>{title}</ContentTitle>}
            <LatestTransactions />
        </div>
    );
};

export default CMSTransactionStream;
